import React, { Component } from 'react';
import styles from './SearchAutocomplete.module.css';
import { Input } from 'reactstrap';
import { restructureResponse } from '../../helpers/sparql';
import magnifyingGlass from '../../images/magnifying-glass.svg';
import cross from '../../images/cross.svg';

class SearchAutocomplete extends Component {
  state = {
    searchValue: '',
    validItems: [],
    showPopup: false,
    selectedIndex: 0
  };

  handleKeyPress = e => {
    if (e.key === 'Enter') {
      if (!this.state.validItems.length) return;
      let selectedItem = this.state.validItems[this.state.selectedIndex];
      let objectURIKey = this.props.data.head.vars[1];
      this.publish(selectedItem[objectURIKey]);
    } else if (e.key === 'ArrowDown') {
      let selectedIndex = this.state.selectedIndex;
      let validItems = this.state.validItems;
      if (selectedIndex === validItems.length - 1) return;
      this.setState({
        selectedIndex: this.state.selectedIndex + 1
      });
    } else if (e.key === 'ArrowUp') {
      let selectedIndex = this.state.selectedIndex;
      if (selectedIndex === 0) return;
      this.setState({
        selectedIndex: this.state.selectedIndex - 1
      });
    } else if (e.key === 'Escape') {
      this.setState({searchValue: ''});
    }
  };

  onChange = e => {
    let objectKey = this.props.data.head.vars[0];
    let searchValue = e.target.value;
    let items = restructureResponse(this.props.data);
    let validItems = items.filter(
      item => item[objectKey] && item[objectKey].toLowerCase().includes(searchValue.toLowerCase())
    );
    this.setState({
      searchValue,
      showPopup: true,
      validItems,
      selectedIndex: 0
    });
  };

  onBlur = e => {
    setTimeout(() => {
      this.setState({
        showPopup: false
      });
    }, 300);
  };

  publish = objectURI => {
   // console.log(objectURI);
    let publishVariable = this.props.publishVariable;
    this.props.publish(publishVariable, objectURI);
    this.setState({
      showPopup: false
    });
  };

  renderLabel(label, searchValue) {
    let ind = label.toLowerCase().indexOf(searchValue.toLowerCase());
    if (ind === -1) {
      return <div>{label}</div>;
    }
    let end = ind + searchValue.length;
    let l1 = label.slice(0, ind);
    let l2 = label.slice(ind, end);
    let l3 = label.slice(end);
    return (
      <div>
        <span>{l1}</span>
        <span style={{ fontWeight: 'bold' }}>{l2}</span>
        <span>{l3}</span>
      </div>
    );
  }

  renderValidItems() {
    if (!this.props.data) return;
    let objectKey = this.props.data.head.vars[0];
    let objectURIKey = this.props.data.head.vars[1];
    let searchValue = this.state.searchValue;
    let validItems = this.state.validItems;
    let selectedIndex = this.state.selectedIndex;
    let selectedItem = validItems[selectedIndex];

    if (!searchValue) return null;
    if (!validItems.length) return <div className={styles.noResults}>geen resultaten gevonden</div>;
    if (!this.state.showPopup) return null;

    return (
      <div className={styles.items}>
        {validItems.map((item, index) => {
          let isSelected = selectedItem && selectedItem[objectURIKey] === item[objectURIKey];

          return (
            <div
              key={index}
              className={styles.item + ' ' + (isSelected ? styles.selected : '')}
              onClick={() => this.publish(item[objectURIKey])}>
              {this.renderLabel(item[objectKey], searchValue)}
            </div>
          );
        })}
      </div>
    );
  }

  render() {
    let mainStyle = {
      alignItems: this.props.alignItems || 'stretch'
    };

    let css = this.props.cssEscape;
    if (css) {
      try {
        css = JSON.parse(css);
        mainStyle = {
          ...mainStyle,
          ...css
        };
      } catch (error) {
        console.log(error)
      }
    }

    return (
      <div className={styles.main} style={mainStyle}>
        <div className={styles.inputContainer}>
          <Input
            value={this.state.searchValue}
            component="input"
            type="text"
            onKeyDown={this.handleKeyPress}
            onChange={this.onChange}
            onBlur={this.onBlur}
          />
          {
            this.state.searchValue ? (
              <img style={{cursor:'pointer'}} onClick={()=> this.setState({searchValue: ''})} src={cross} alt="empty" />
            ): (
              <img src={magnifyingGlass} alt="magnifying glass" />
            ) 
          }
          
        </div>
        {this.renderValidItems()}
      </div>
    );
  }
}

export default SearchAutocomplete;
